import React from "react"
import { Container } from "reactstrap"

import Breadcrumb from "components/Common/Breadcrumb"
import MyICDList from "./myIcds"

const MyRequests = () => {
  //meta title
  document.title = "My Fund Requests - Prachay"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={"My Fund Requests"}
            breadcrumbItem={"My Fund Requests"}
          />
          <MyICDList />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default MyRequests
